import { render, staticRenderFns } from "./PageAccessSSOExpress.vue?vue&type=template&id=42f4207c&scoped=true&"
import script from "./PageAccessSSOExpress.vue?vue&type=script&lang=js&"
export * from "./PageAccessSSOExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f4207c",
  null
  
)

export default component.exports